import { computed, ref } from 'vue'
import { getSummaryInfo, aiSummaryRetry, getFillPreview } from '@/api/workPlace/summary'
import { message as Message } from 'ant-design-vue'
// import { TYPE } from '@/constants/columns'
import { useStore } from 'vuex'
export function useSummary(getData) {
  const store = useStore()
  const summaryActive = ref(0)
  const editSummaryRef = ref(null)
  const chatSummaryId = ref('')
  const summaryPanelVisible = ref(false)
  const retryLoading = ref(false)
  const ucUserId = computed(() => store.state.user.userInfo.ucUserId)
  /**
   * 查看小结
   * @param {*} record 列表的数据
   * @param {*} tabActiveKey 需要进入的tab页面 0：小结内容（默认值）、1:聊天记录、2:通话记录、3:操作记录
   */
  const handleSummary = async (record, tabActiveKey = 0) => {
    const { writeSummaryCheck, chatSummaryId: id } = record
    summaryActive.value = tabActiveKey
    if (!writeSummaryCheck) {
      chatSummaryId.value = id
      summaryPanelVisible.value = true
    } else {
      // NOTE: 一定会有小结ID 后端会生成兜底小结id
      const res = await getSummaryInfo({ chatSummaryId: id })
      const params = {
        groupInfo: res,
        isEdit: true,
        type: res.type,
        aiSummaryContents: res.type === 1 ? JSON.parse(res.contents) : res.content
      }
      editSummaryRef.value?.initModal(params)
    }
  }

  // 重新生成提示
  const onCreateSummary = record => {
    const { chatSummaryStatus, chatSummaryRetryCount, cdrId } = record
    const tips = '重试次数超过限制'
    if ([1, 2].includes(chatSummaryStatus) || chatSummaryRetryCount > 1) return Message.info(tips)
    retrySummary(cdrId)
  }

  // 重新生成AI小结
  const retrySummary = async cdrId => {
    if (retryLoading.value) return

    retryLoading.value = true
    try {
      await aiSummaryRetry({ cdrId })
      Message.success('操作成功')
      if (typeof getData === 'function') {
        getData()
      }
    } catch (error) {
      console.log(error)
    } finally {
      retryLoading.value = false
    }
  }

  const closeSummaryModal = () => {
    summaryPanelVisible.value = false
  }
  /**
   * NOTE: 创建电话沟通小结的异步函数( 手动改状态专用接口 )
   * @param {Object} record - 记录对象，包含相关信息
   * @param {number} [type=0] - 小结类型，默认值为0
   */
  const createSummary = async (record, type = 0) => {
    const res = await getFillPreview({ cdrId: record.cdrId })
    // 0未知患者 ：1患者2医生 3BD 4医助 5预患者
    // res.callerType
    const {
      doctorInfo,
      patientInfo,
      bdUcUserId,
      bdName,
      callerType,
      unProcessedStatusFlag,
      pendingCdrIds
    } = res
    // 构建小结参数对象
    const params = {
      callerType,
      type: type,
      typeStatus: 1,
      msgIdList: [],
      cdrId: record.cdrId,
      // 如果是通话失败的 不需要复值
      cdrIds: unProcessedStatusFlag ? [] : [record.cdrId],
      callBelongUcUserId: ucUserId.value,
      pendingCdrIds,
      groupInfo: {
        patientProfileCommonVO: {
          patientProfileName: patientInfo?.patientName,
          gender: patientInfo?.gender,
          age: patientInfo?.age
        },
        patientName: patientInfo?.patientName,
        ucPatientId: patientInfo?.ucPatientId,
        doctorName: doctorInfo?.doctorName,
        ucDoctorId: doctorInfo?.ucDoctorId,
        prePatientId: patientInfo?.prePatientId,
        bdUcUserId: bdUcUserId,
        bdName: bdName
      },
      workOrderId: record.workOrderIds[0],
      callChatSummaryVO: {
        source: 4,
        chatType: null,
        chatBusinessId: record.cdrId,
        ucDoctorId: doctorInfo?.ucDoctorId,
        doctorId: doctorInfo?.doctorId,
        doctorName: doctorInfo?.doctorName,
        ucPatientId: patientInfo?.ucPatientId,
        patientName: patientInfo?.patientName,
        gender: patientInfo?.gender,
        age: patientInfo?.age,
        prePatientId: patientInfo?.prePatientId
      }
    }
    // console.log('groupInfo', res)
    // 调用编辑小结组件的初始化方法，传入参数
    editSummaryRef.value?.initModal(params)
  }

  return {
    summaryActive,
    editSummaryRef,
    chatSummaryId,
    summaryPanelVisible,
    handleSummary,
    onCreateSummary,
    retrySummary,
    closeSummaryModal,
    createSummary
  }
}
